import Vue from 'vue'
import VueI18n from 'vue-i18n'
import fr from '@/lang/fr.json'
import en from '@/lang/en.json'
import es from '@/lang/es.json'
import Cookies from 'js-cookie'

Vue.use(VueI18n)

const locale = Cookies.get('locale', { domain: process.env.DOMAIN }) || 'en'
const messages = {
  fr,
  en,
  es
}
const i18n = new VueI18n({
  locale,
  fallbackLocale: 'fr',
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js